import { SquarePlus } from "lucide-react";
import { ACTION_BAR_HEIGHT } from "@/common/constants";
import { Button } from "../ui/button";

export default function TaskTableActionBar({
    onClick,
    disabled,
}: {
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    disabled: boolean;
}) {
    return (
        <div
            className="pl-2 pt-1"
            style={{
                height: `${ACTION_BAR_HEIGHT}px`,
            }}
        >
            <Button variant="ghost" size="sm" className="text-sm text-zinc-400" onClick={onClick} disabled={disabled}>
                <SquarePlus className="size-4" />
                Add task
            </Button>
        </div>
    );
}
